import moment from 'moment'

export const convertUTCTimeToLocal = time => moment.utc(time).local().format('Do MMM YYYY, HH:mm')
